/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateGrantsControllerFindAllQueryResponse, TemplateGrantsControllerFindAllQueryParams, TemplateGrantsControllerFindAll401, TemplateGrantsControllerFindAll403 } from "../../models/checklistsController/TemplateGrantsControllerFindAll";

function getTemplateGrantsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-template-grants` as const }  
  return res
}

/**
 * @summary List granted templates for a scope
 * {@link /api/v1/checklist-template-grants}
 */
export async function templateGrantsControllerFindAll(params: TemplateGrantsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateGrantsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateGrantsControllerFindAll401 | TemplateGrantsControllerFindAll403>, unknown>({ method : "GET", url : getTemplateGrantsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}